import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import { ecosystemAppClient, ecosystemPublicClient } from 'ecosystem-marketplace-core/common/clients/ecosystemClient';
import { TYPEAHEAD_SEARCH_RESULTS_LIMIT } from 'ecosystem-marketplace-core/constants/search';
import ThemeSearchBarResult from 'ecosystem-marketplace-core/assets/components/ThemeSearchBarResult';
import { getModuleDetailPageFullUrl, getPublicModuleDetailPageFullUrl } from '../../utils/urls';
export const VIEW_ALL_MODULES = '__VIEW_ALL_MODULES__';
export function useModuleSearchBarQuery({
  appContext = 'app',
  grouped = false,
  limit = TYPEAHEAD_SEARCH_RESULTS_LIMIT
} = {}) {
  const fetcher = useCallback(input => {
    const client = appContext === 'public' ? ecosystemPublicClient : ecosystemAppClient;
    const response = client.post('modules/search', {
      data: [{
        limit,
        search: input
      }]
    });
    return response.then(([{
      items,
      total
    }]) => {
      const lang = getLang();
      const options = items.map(item => {
        const {
          companyName,
          name,
          offeringId,
          slug,
          thumbnailUrl
        } = item;
        const itemDetailsUrl = appContext === 'app' ? getModuleDetailPageFullUrl(slug) : getPublicModuleDetailPageFullUrl(lang, slug); // TODO: Make generic AssetSearchBarResult or create ModuleSearchBarResult component

        return {
          dropdownText: /*#__PURE__*/_jsx(ThemeSearchBarResult, {
            companyName: companyName,
            name: name,
            thumbnailUrl: thumbnailUrl
          }),
          href: itemDetailsUrl,
          item,
          linkUse: 'unstyled',
          text: name,
          value: `module::${offeringId}`,
          slug
        };
      });

      if (total > limit) {
        const viewAllModulesUrl = appContext === 'app' ? getModuleDetailPageFullUrl(`?eco_search=${input}`) : getPublicModuleDetailPageFullUrl(lang, `?eco_search=${input}`);
        options.push({
          href: viewAllModulesUrl,
          text: I18n.text('marketplace-assets-ui.modules.searchBar.viewAll', {
            total
          }),
          value: VIEW_ALL_MODULES
        });
      }

      return options;
    }).then(options => grouped ? [{
      text: I18n.text('marketplace-assets-ui.modules.searchBar.groupLabel'),
      options
    }] : options);
  }, [appContext, grouped, limit]);
  return {
    fetcher
  };
}